var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{attrs:{"id":"picked"}},[_c('transition-group',{attrs:{"name":"slide"}},_vm._l((_vm.pickedNames),function(person,index){return _c('p',{key:("" + (person.id) + index)},[_vm._v(_vm._s(person.name))])}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }